import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { multiFactor } from 'firebase/auth';
import { KeyRound, Loader2, LogOut, ShieldAlert } from 'lucide-react';
import { auth } from '@/lib/firebase';
import { useAuthStore } from '@/stores/authStore';
import { useAdminMfaStore } from '@/stores/adminMfaStore';

/** Exibido quando a API responde 403 MFA_REQUIRED em rotas de administração. */
export function AdminMfaRequired() {
  const navigate = useNavigate();
  const signOut = useAuthStore((state) => state.signOut);
  const setMfaRequired = useAdminMfaStore((state) => state.setMfaRequired);
  const [isSigningOut, setIsSigningOut] = useState(false);
  const hasEnrolledFactor = auth.currentUser ? multiFactor(auth.currentUser).enrolledFactors.length > 0 : false;

  const handleGoToEnrollment = () => {
    // Libera o layout para renderizar o Perfil (fora das rotas de admin)
    setMfaRequired(false);
    navigate('/dashboard/perfil?aba=seguranca');
  };

  const handleSignOut = async () => {
    setIsSigningOut(true);
    try {
      await signOut();
      setMfaRequired(false);
      navigate('/login', { replace: true });
    } finally {
      setIsSigningOut(false);
    }
  };

  return (
    <div className="mx-auto max-w-xl py-10">
      <div className="card text-center" role="alert">
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-warning/10 text-warning">
          <ShieldAlert className="h-6 w-6" aria-hidden="true" />
        </span>
        <h1 className="mt-4 font-display text-xl font-semibold text-ink">Verificação em duas etapas obrigatória</h1>
        <p className="mt-2 text-sm text-muted">
          O painel de administração só pode ser acessado com uma sessão autenticada por verificação em duas etapas
          (MFA). Sua sessão atual foi iniciada sem esse segundo fator.
        </p>
        {hasEnrolledFactor ? (
          <>
            <p className="mt-2 text-sm text-muted">
              Sua conta já tem a verificação em duas etapas ativada. Saia e entre novamente informando o código do app
              autenticador.
            </p>
            <button type="button" onClick={handleSignOut} disabled={isSigningOut} className="btn-primary mt-6">
              {isSigningOut ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> : <LogOut className="h-4 w-4" aria-hidden="true" />}
              Sair e entrar novamente
            </button>
          </>
        ) : (
          <>
            <p className="mt-2 text-sm text-muted">
              Ative a verificação em duas etapas no seu perfil (leva cerca de 1 minuto com um app autenticador). Depois,
              saia e entre de novo.
            </p>
            <div className="mt-6 flex flex-col justify-center gap-2 sm:flex-row">
              <button type="button" onClick={handleGoToEnrollment} className="btn-primary">
                <KeyRound className="h-4 w-4" aria-hidden="true" />
                Ativar agora
              </button>
              <button type="button" onClick={handleSignOut} disabled={isSigningOut} className="btn-ghost">
                {isSigningOut ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> : <LogOut className="h-4 w-4" aria-hidden="true" />}
                Sair
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
